export const configurationValidation = {
  engineeringPolicy: {
    type: 'object',
    properties: {
      productionOwnership: {
        type: 'string',
        required: true,
      },
      deliveryModel: {
        type: 'string',
        required: true,
      },
      ppcLink: {
        type: 'string',
        required: true,
        link: true,
      },
    },
  },
};
